<div
  cdkDrag
  class="pnl-pivot-table-drag resize-able pnl-pivot-container"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
  cdkDragBoundary=".exotics-main"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
  appResizerVertical
  appResizerHorizontal
  minWidth="640"
  minHeight="300"
>
  <div class="menu-bar" cdkDragHandle (mousedown)="updateZIndex()">
    <div class="pnl-pivot-table-container-content__menu-bar__title">
      PnL Pivot Table
    </div>
    <button class="button-close" (click)="closeGrid()"></button>
  </div>

  <div class="ag-theme-balham-dark ag-grid-container">
    <ag-grid-angular
      [groupIncludeFooter]="false"
      [groupIncludeTotalFooter]="false"
      [rowGroupPanelShow]="'always'"
      [rowData]="rowData"
      [columnDefs]="headers"
      [sideBar]="sideBarDef"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (sortChanged)="gridStateChanged($event)"
      (columnResized)="gridStateChanged($event)"
      (columnVisible)="gridStateChanged($event)"
      (columnMoved)="gridStateChanged($event)"
      (columnPivotChanged)="gridStateChanged($event)"
      (columnRowGroupChanged)="gridStateChanged($event)"
      (columnValueChanged)="gridStateChanged($event)"
      (columnMoved)="gridStateChanged($event)"
      (columnPinned)="gridStateChanged($event)"
      class="pnl-ag-grid ag-theme-balham-dark"
    >
    </ag-grid-angular>
  </div>
  <div class="ag-floating-bottom"></div>
  <div class="pnl-pivot-container__footer">
    <div class="pnl-pivot-container__footer__timestamp">
      {{ timestamp | date: 'medium' }}
    </div>
    <button (click)="clearFilters()" class="ui-button ui-button__footer">
      <cds-icon shape="filter-grid"></cds-icon>
      Reset Grid
    </button>
  </div>
</div>
